export async function getBlogPosts() {
  const url =
    "https://docs.google.com/spreadsheets/d/1Xt_hbMUGRNVaPJug6BX1OxX6i-abez03-lORxVfjyzM/gviz/tq?tqx=out:json&gid=0";

  const response = await fetch(url);
  const text = await response.text();

  const jsonText = text.substring(47).slice(0, -2);
  const json = JSON.parse(jsonText);

  const rows = json.table.rows;

  return rows.map((row) => ({
    id: row.c[0]?.v || "",
    title: row.c[1]?.v || "",
    category: row.c[2]?.v || "",
    excerpt: row.c[3]?.v || "",
    content: row.c[4]?.v || "",
    cover: row.c[5]?.v || "",
    date: row.c[6]?.v || "",
    status: row.c[7]?.v || "",
  }));
}